module.exports = __webpack_public_path__ + "c29c1b08b83dd6b56eb62902bf2ad84c.eot";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = 480
// module chunks = 1